const getters = {
  token: (state) => state.user.token,
  isShowModal: (state) => state.mapGeo.isShowModal,
  mychart: (state) => state.dashboard.mychart,
  yearList: (state) => state.dashboard.yearList,
  isFullScreen: (state) => state.dashboard.isFullScreen,
  layout: (state) => state.dashboard.layout,
  widthRatio: (state) => state.dashboard.widthRatio,
  heightRatio: (state) => state.dashboard.heightRatio,
  boxWidthHeight:(state)=>state.dashboard.boxWidthHeight,
  preWarnInfo:(state)=>state.dashboard.preWarnInfo,
  isShowModalPreWarning:(state)=>state.dashboard.isShowModalPreWarning,
  isShowModalPreWarningDetail:(state)=>state.dashboard.isShowModalPreWarningDetail,
  preWarningDetailContent:(state)=>state.dashboard.preWarningDetailContent,
  listCount:(state)=>state.dashboard.listCount,
  isShowModalOneTouch: (state) => state.dashboard.isShowModalOneTouch,
  isShowModalPreWarn: (state) => state.dashboard.isShowModalPreWarn,
  isShowModalWarn: (state) => state.dashboard.isShowModalWarn,
  provinceObj:(state) => state.dashboard.provinceObj,
  dashName:(state) => state.dashboard.dashName,
  isShowModalLinkPanel:(state) => state.dashboard.isShowModalLinkPanel,
  isLinkModal:(state) => state.dashboard.isLinkModal,
  dashType:(state) => state.dashboard.dashType,
  provinceObj:(state) => state.mapGeo.provinceObj
}
export default getters
